import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LogService } from '@pershing/pershing-core';
import { ALERT_MESSAGE_LEVEL } from '../../../utils/trading-constants';

@Component({
  selector: 'alert-message-dialog',
  templateUrl: './alert-message-dialog.component.html',
  styleUrls: ['./alert-message-dialog.component.css']
})
export class AlertMessageDialogComponent implements OnInit {

  divClassStr: string;
  activeTheme: string;

  constructor(private logService: LogService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.activeTheme = this.data.activeTheme === 'comfortable' ? 'comfortable' : 'compact';;
    if ( this.data.msgLevel===ALERT_MESSAGE_LEVEL.warn ) {
      this.divClassStr = 'alert-inpage warn modal-message';
    }

    if ( this.data.msgLevel===ALERT_MESSAGE_LEVEL.info ) {
      this.divClassStr = 'alert-inpage info modal-message';
    }

    if ( this.data.msgLevel===ALERT_MESSAGE_LEVEL.confirm ) {
      this.divClassStr = 'alert-inpage confirm modal-message';
    }

    if ( this.data.msgLevel===ALERT_MESSAGE_LEVEL.error ) {
      this.divClassStr = 'alert-inpage error modal-message';
    }
  }

}
